import * as React from 'react';
import { useDispatch } from 'react-redux';
import { ThunkDispatch } from '~/Store';
import TypedSelect from '~/UI/Select/TypedSelect';

export const BASE_SCENARIO_ID = 'base-scenario-id';

const ERPScenarioSelect = ({
	disabledScenarioId,
	selectedScenarioId,
	scenarios,
	onScenarioSelect,
}: {
	disabledScenarioId?: string | null;
	selectedScenarioId?: string | null;
	scenarios: {
		id: string | null;
		name: string;
	}[];
	onScenarioSelect?: (scenarioId: string) => void;
}) => {
	// TODO: Add correct type
	const dispatch = useDispatch<ThunkDispatch<any>>();
	return (
		<TypedSelect
			className='w-full h-8 px-1 border border-gray-200 rounded-sm font-roboto text-label font-semibold leading-none text-black truncate bg-gray-100 bg-opacity-60 cursor-pointer align-top'
			options={scenarios.map(({ id, name }) => ({
				disabled: id === disabledScenarioId,
				value: id,
				title: name,
			}))}
			value={selectedScenarioId || ''}
			onTypedValueChange={(value) => {
				if (value === '') {
					return;
				}

				dispatch(onScenarioSelect?.(value));
			}}
		/>
	);
};

export default React.memo(ERPScenarioSelect);
